import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import { Grid, Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CustomModal from "../../components/Modal/CustomModal";
import { Card } from "../../components/Card/Card";
import logo from "../../assets/img/logo-TAD-d.png";
import { Url } from '../../shared/Url';
import Post from '../../shared/Post';

import { SendForgotMail } from '../../funciones/ForgotFunction'
import TiempoRestante from '../Componentes/TiempoRestante';

let statusBtn = 0;
let fechaRestante = "Mar 09 2020 00:00:00 GMT-4";

class Login extends Component {
    state = {
        login: false,
        title: "¿Qué es esto?",
        user:{
            text: "",
            status: ""
        },
        pass: {
            text: "",
            status: ""
        },
        button: {
            Icon:"fa fa-sign-in",
            Title:"Ingresar",
            disabled: false
        },
        openW: false,
        openWForgot: false,
        tituloModal: "",
        contenidoModal: "",
        buttonForgot: {
            icon:"fa fa-envelope",
            text:"Si, envíame un Email"
        },
        statusMsj: "custom-alert-info custom-mt-10",
        statusText: "Ingresa el email con el que te registraste",
        textMail: "",
    }

    funcion1 = () => {
        let usuario = this.state.user.text;
        this.setState ({
            openW: false,
            openWForgot: false,
            tituloModal: "",
            contenidoModal: "",
            buttonForgot: {
                Icon:"fa fa-spinner fa-spin",
                Title:"Enviando Código"
            }
        },() => {
            let Content = { User: usuario };

            Post(`${Url}validateSend`, Content, (resp) => {
                let data = JSON.parse(resp);
                
                this.setState ({
                    button: {
                        Icon:"fa fa-sign-in",
                        Title:"Ingresar",
                        disabled: false
                    },
                },() => {
                    if (data.status === "0"){
                        toast.error(<div className="fuente-monserrat">{data.mensaje}</div>,{});
                        return null;
                    }
                    this.showModal ();
                    toast.info(<div className="fuente-monserrat">{data.mensaje}</div>,{});
                });
            });
        });
    }

    showModal = () => {
        const { openW, tituloModal, contenidoModal } = this.state;
        let boton1Modal = "Reenviar Código"
        let boton2Modal = "Aceptar"
        return (
            <CustomModal
                isopen =  {openW}
                titulo = {<div className="text-primary fuente-monserrat">{tituloModal}</div>}
                contenido = {contenidoModal}
                boton1 = {boton1Modal}
                boton2 = {boton2Modal}
                funcion1 = {this.funcion1}/>
        );
    }

    showModalForgot = () => {
        const { openWForgot, buttonForgot, statusMsj, textMail, statusText } = this.state;

        let sendMailForgot = () => {
            let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;


            if (textMail === "") {
                this.setState({
                    statusMsj: "custom-alert-danger custom-mt-10",
                    statusText: "El campo de Email es obligatorio"   
                })
                return null;
            }

            if(expReg.test(textMail) === false){
                this.setState ({
                    statusMsj: "custom-alert-danger custom-mt-10",
                    statusText: "El campo Correo Electrónico debe tener un formato válido"
                });
                return null;
            }


            this.setState({
                buttonForgot: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Enviando, espera por favor"
                }
            }, () => {
                SendForgotMail (textMail, (resp) => {
                    if(resp.status === 0) {
                        this.setState ({
                            buttonForgot: {
                                icon:"fa fa-envelope",
                                text:"Si, envíame un Email"
                            },
                            textMail: "",
                            openWForgot: false
                        }, () => {
                            toast.error(<div className="fuente-monserrat">El email ingresado no se encuentra registrado</div>,{});
                        });
                        return null;
                    }

                    this.setState ({
                        buttonForgot: {
                            icon:"fa fa-envelope",
                            text:"Si, envíame un Email"
                        },
                        textMail: "",
                        openWForgot: false
                    }, () => {
                        toast.info(<div className="fuente-monserrat">Te hemos enviado un email con el enlace de restauración de tu contraseña</div>,{});
                    });
                })
            })
        }

        let contenidoMess = () => (
            <React.Fragment>
                <div className="fuente-monserrat">
                    Esta opción te enviará un Email para restaurar tu contraseña. <strong>¿Deseas continuar?</strong>
                </div>
                <div className={statusMsj}>
                    <span className="fuente-monserrat">{statusText}</span>
                    <input type="text" value={textMail} onChange = {this.cambiaValorForgot()} className="form-control" placeholder="Ej.: ejemplo@gmail.com"/>
                    <span className="fuente-monserrat">Hasta que no valides tu contraseña mantendrás la que tienes actualmente</span>
                </div>
            </React.Fragment>
        );

        return (
            <CustomModal
                isopen =  {openWForgot}
                titulo = {<div className="text-primary fuente-monserrat">Restaurar Contraseña</div>}
                contenido = {contenidoMess()}
                boton1 = {<div className="fuente-monserrat"><i className={buttonForgot.icon}></i> {buttonForgot.text}</div>}
                boton2 = {<div className="fuente-monserrat">Cancelar</div>}
                funcion1 = {sendMailForgot}/>
        );
    }

    forgotPass = () => (e) => {
        this.setState({
            buttonForgot: {
                icon:"fa fa-envelope",
                text:"Si, envíame un Email"
            },
            statusMsj: "custom-alert-info custom-mt-10",
            statusText: "Ingresa el email con el que te registraste",
            textMail: "",
            openWForgot:true
        })
    }

    consultaBdDatos = (user, pass) => {
        let eData = "U_EDUEYSS";        
        let Content = {
            User: user,
            Pass: pass,
            eData: btoa(eData)
        }
        Post(`${Url}seachUser`, Content, (resp) => {
            let data = JSON.parse(resp);
            if (data.statusUser === "0"){
                this.setState ({
                    button: {
                        Icon:"fa fa-sign-in",
                        Title:"Ingresar",
                        disabled: false
                    },
                    openW: true,
                    openWForgot: false,
                    tituloModal: "No puede iniciar sesión",
                    contenidoModal: data.message
                },() => {
                    this.showModal ();
                });
                return null;
            }
            switch (data.status) {
                case 0:
                    this.setState ({
                        button: {
                            Icon:"fa fa-sign-in",
                            Title:"Ingresar",
                            disabled: false
                        },
                    },() => {
                        toast.error(<div className="fuente-monserrat">{data.message}</div>,{});
                    });
                    return null;
                case 1:
                    this.setState ({
                        login: true,
                    },() => {
                        /* document.cookie =`S_ID=${data.s_id}; max-age=120000; path=/`;
                        document.cookie =`U_ID=${data.u_id}; max-age=120000; path=/`; */
                        document.cookie =`S_ID=${data.s_id}; path=/`;
                        document.cookie =`U_ID=${data.u_id}; path=/`;
                    });
                    return null;
                default:
                    return null;
            }
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:event.target.value,
                status: ""
            },
            openW: false,
            openWForgot: false
        });
    };

    cambiaValorText = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toLowerCase(),
                status: ""
            },
            openW: false,
            openWForgot: false
        });
    };

    cambiaValorForgot = () => (event) => {
        this.setState({ textMail: event.target.value })
    };

    login = () => (e) => {
        if (this.state.button.disabled === true) return null;
        
        let { user, pass } = this.state;
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

        if(user.text === ""){toast.error(<div className="fuente-monserrat">El campo Correo Electrónico no debe estar vacío</div>,{});return null}
        if(expReg.test(user.text) === false){
            this.setState ({
                user: {
                    status: "has-error"
                }
            },() => {
                toast.error(<div className="fuente-monserrat">El campo Correo Electrónico debe tener un formato válido</div>,{});
            });
            return null;
        }
        if(pass.text === ""){toast.info(<div className="fuente-monserrat">El campo Contraseña no debe estar vacío</div>,{});return null}

        
        this.setState ({
            button: {
                Icon:"fa fa-spinner fa-spin",
                Title:"Validando",
                disabled: true
            }
        },() => {
            this.consultaBdDatos (user.text, pass.text)
        });
    }

    enterTab = (next) => (e) => {if (e.which === 13) document.getElementById(next).focus();}

    enterLogin = () => (e) => {if (e.which === 13){
        if (statusBtn === 1) return null;

        let { user, pass } = this.state;
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

        if(user.text === ""){toast.error(<div className="fuente-monserrat">El campo Correo Electrónico no debe estar vacío</div>,{});return null}
        if(expReg.test(user.text) === false){
            this.setState ({
                user: {
                    status: "has-error"
                }
            },() => {
                toast.error(<div className="fuente-monserrat">El campo Correo Electrónico debe tener un formato válido</div>,{});
            });
            return null;
        }
        if(pass.text === ""){toast.info(<div className="fuente-monserrat">El campo Contraseña no debe estar vacío</div>,{});return null}

        
        this.setState ({
            button: {
                Icon:"fa fa-spinner fa-spin",
                Title:"Validando"
            }
        },() => {
            this.consultaBdDatos (user.text, pass.text)
        });
    }}

    titulo = () => (
        <Row>
            <Col md={3}>
                <img src={logo} alt="User" className="img img-responsive"
                        style={{height:"auto", width:35}}/>
            </Col>
            <Col md={9} align="right">
                <span className="fuente-monserrat">Inicia Sesión</span>
                <div className="text-muted fuente-monserrat" style={{fontSize:12, marginTop:-10}}>Para continuar ingresa tu usuario y contraseña</div>
            </Col>
            
        </Row>
    )

    botones = () => {
        let { button } = this.state;

        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-relleno-primary fuente-monserrat" onClick = {this.login()} id="login" style={{borderWidth:1}}><i className= {button.Icon}></i>{button.Title}</button>
                )
            case 1:
                let proximamente = (
                    <Popover title="Importante" id="pass" className="fuente-monserrat">
                        <div align="center">El Sistema se encuentra en mantenimiento.</div>
                        <TiempoRestante fechaFinal = {fechaRestante}/>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={proximamente}>
                        <button className="btn btn-primary fuente-monserrat" id="register" style={{borderWidth:1}}><i className= {button.Icon} style={{fontSize:16}}></i> {button.Title}</button>
                    </OverlayTrigger>
                )
            default:
                return (<div></div>)
        } 
    }
    contenido = () => {
        let { user, pass, title } = this.state;

        let help1 = (
            <Popover title="Nombre de Usuario" id="username" className="fuente-monserrat">
                Introduce el <strong>Correo Electrónico</strong> con el cual te registraste. <br/>
                Ej: <strong style={{color:"#1f2f6e"}}>example@exampĺe.com</strong>
            </Popover>
        )

        let help2 = (
            <Popover title="Contraseña" id="userpass" className="fuente-monserrat">
                Introduce la <strong>Contraseña</strong> con la cual te registraste y presiona <strong style={{color:"#1f2f6e"}}>Ingresar</strong>
            </Popover>
        )

        return (
            <React.Fragment>
            
            <Grid fluid>
                <Row>
                    <Col md={10}>
                        <div className={`${user.status} form-group has-feedback`}>
                            <input onChange={this.cambiaValorText("user")} value = {user.text} onKeyPress={this.enterTab("pass")} type="email" placeholder="Correo electrónico" className="form-control"/>
                            <i className="form-control-feedback pe-7s-id"></i>
                        </div>
                    </Col>
                    <Col md={2} align="right">
                    <OverlayTrigger trigger="focus" placement="right" overlay={help1}>
                        <button className="btn btn-warning" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                    </OverlayTrigger>
                    </Col>
                    <Col md={10}>
                        <div className={`${pass.status} form-group has-feedback`}>
                            <input type="password" id="pass" onChange={this.cambiaValor("pass")} onKeyPress={this.enterLogin()} placeholder="Contraseña" className="form-control"/>
                            <i className="form-control-feedback pe-7s-key"></i>
                        </div>
                    </Col>
                    <Col md={2} align="right">
                        <OverlayTrigger trigger="focus" placement="right" overlay={help2}>
                            <button className="btn btn-warning" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                    <Col md={6} style={{paddingTop:10}}>
                        <button className="btn btn-primary" style={{borderWidth:1, marginRight: 8}} onClick={this.forgotPass()}><i className="fa fa-key"></i> Olvidé mi contraseña</button>

                        {/* <a style={{cursor:"pointer"}} onClick={this.forgotPass()} className="fuente-monserrat">Olvidé mi contraseña</a>
                        <div className = "text-danger fuente-monserrat" style={{fontSize: 13}}>
                            ¿Problemas con esta ventana? Escribe a <strong>soporte@iudlm.com</strong>
                        </div> */}
                    </Col>
                    <Col md={6} align="right" style={{paddingRight:1, paddingTop:10}}>
                        {this.botones()}
                    </Col>
                </Row>
            </Grid>
            </React.Fragment>
        );
    }
    
    render() {
        
        if(this.state.login === true) return(<Redirect to="/noticias" />)
        return (
            <div className="login-content" style={{position:"fixed"}}>
                <React.Fragment>
                    <div className="wrapper2">
                        <div className="wave one"></div>
                        <div className="wave dos"></div>
                        <div className="wave tres"></div>
                        <div className="wave cuatro"></div>
                    </div>
                </React.Fragment>
                <Grid fluid>
                    <Row>
                        <Col md={3}></Col>
                        <Col md={6}>
                            <div style={{/* boxShadow: "1px 1px 2px #000", */ borderRadius: "4px 4px",}}>
                                <Card
                                    title={this.titulo()}
                                    color="#a80012"
                                    content={this.contenido()}
                                />
                            </div>
                        </Col>
                        <Col md={3}></Col>
                    </Row>
                </Grid>
                <div align="center" style={{color:"#777"}}>
                    &copy; {new Date().getFullYear()} Diseñado y Desarrollado por <a href = "https://www.eyss-dev.com/">
                    <span style = {{color:"#4885ed"}}>E</span>
                    <span style = {{color:"#dc3d36"}}>Y</span>
                    <span style = {{color:"#f4c230"}}>S</span>
                    <span style = {{color:"#62bc55"}}>S</span>
                    </a>
                </div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={3000}/>
                {this.showModal()}
                {this.showModalForgot()}
            </div>
        );
    }
}
 
export default Login;


// WEBPACK FOOTER //
// ./src/site/Views/Login.jsx